import React from "react";
import "./index.scss";
import { Icon, Input, Select } from "antd";
import { Link } from "react-router-dom";

export default ({ search, select, roles, filterUserList }) => (
  <div className="user-filter-container">
    <h3>Active Users</h3>
    <div className="user-filter">
      <Input
        type="search"
        placeholder="Search User"
        className="search-input"
        value={search}
        onChange={e => filterUserList(e, "search")}
      />
      <Select
        value={select}
        className="search-select"
        onChange={v => filterUserList({ target: { value: v } }, "select")}
      >
        <Select.Option value="">All Types</Select.Option>
        {roles.map((role, index) => (
          <Select.Option key={index} value={role.title}>
            {role.title}
          </Select.Option>
        ))}
      </Select>
      {/* <Link to='/users/invite'>
          <Icon type='user-add' />  Invite Users
          </Link> */}
    </div>
  </div>
);
